package io

import api.*
import io.ktor.util.*
import kotlinx.coroutines.flow.*
import kotlinx.coroutines.sync.*

class RepoStrings(language: StateFlow<LanguageType>) : ImplRepo(language) {

    private var mapper = mutableMapOf<LanguageType, Map<String, String>>()

    private val lock = Mutex()

    private val simpleStringFormatRegex = Regex("""%(\d)\$[ds]""")

    private fun String.replaceWithArgs(args: List<String>) = simpleStringFormatRegex.replace(this) { matchResult ->
        runCatching {
            args[matchResult.groupValues[1].toInt() - 1]
        }.getOrNull() ?: ""
    }

    suspend fun get(key: String, formatArgs: List<Any>): String {
        return get(key).let {
            if (formatArgs.isEmpty()) it
            else it.replaceWithArgs(formatArgs.map { it.toString() })
        }
    }

    suspend fun get(key: String): String {
        val lang = language.value
        val value = mapper[lang]?.get(key)

        if (value == null) fetch(lang, key)
        else return value

        return mapper[lang]?.get(key) ?: mapper[LanguageType.English]?.get(key) ?: ""

    }

    private fun String.cvrToMap(): Map<String, String> {
        return lineSequence()
            .map { it.split("|") }
            .filter { it.size > 1 }
            .associateBy({ it[1] }, {
                if (it[2].trim().isEmpty()) ""
                else it[2].decodeBase64String().trimIndent()
            })
    }

    private suspend fun fetch(lang: LanguageType, key: String) {
        lock.withLock {
            val containsTarget = mapper[lang]?.get(key) != null

            if (!containsTarget) {
                runCatching {
                    mapper[lang] = Repository.api.fetchTranslation(lang).cvrToMap()
                }.onFailure {
                    runCatching {
                        mapper[LanguageType.English] = Repository.api.fetchTranslation(LanguageType.English).cvrToMap()
                    }.onFailure {
                        it.printStackTrace()
                    }
                }
            }
        }
    }
}



